import styled from '@emotion/styled';
import { shouldForwardProps } from '../../utils';
import { Stack } from '@mui/material';

const SidenavHeader = styled(Stack, shouldForwardProps)`
    margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export { SidenavHeader };
